<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('exchangeRate.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('exchangeRate.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <!-- <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button> -->
          <Button type="info" ghost @click="addNew()">
            {{ $t('addNew') }}
          </Button>
          <!-- <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div> -->
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
      </Table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('exchangeRate.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="500px"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'exchangeRateIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('exchangeRate/currencyRate', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.exchangeRate.currencyRate.search
      },
      set(newValue) {
        this.$store.commit('exchangeRate/currencyRate/SET_SEARCH', newValue)
        this.$store.commit('exchangeRate/currencyRate/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          title: this.$t('exchangeRate.date'),
          key: 'dates',
          fixed: 'left',
          width: 200
        },
        {
          title: this.$t('exchangeRate.fromCurrency'),
          key: 'fromC'
        },
        {
          title: this.$t('exchangeRate.toCurrency'),
          key: 'toC'
        },
        {
          title: this.$t('exchangeRate.fxRate'),
          key: 'fx_rate'
        },
        {
          title: this.$t('exchangeRate.fxRateRatio'),
          key: 'fx_rate_ratio'
        },
        {
          title: this.$t('exchangeRate.remarks'),
          key: 'remarks'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('exchangeRate/currencyRate/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('exchangeRate/currencyRate/SET_EDIT_DATA', {})
      this.showForm = false
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('exchangeRate/currencyRate/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
